module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/welcome_to_teams.ae3b0daa8fc4a83cb4cc3e60c4104fe0.svg";